import React, { useEffect } from 'react';

interface ViewSubmissionProps {
  submission?: any;
  onBack?: () => void;
}

const ViewSubmission: React.FC<ViewSubmissionProps> = ({ submission, onBack }) => {
    useEffect(() => {
    console.log(submission)
    },[])
  return (
    <div className="p-6">
      <button
        onClick={onBack}
        className="mb-4 inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
      >
        ← Back
      </button>
      <h2 className="text-2xl font-bold mb-2">Submission Details</h2>
      {submission ? (
        <pre className="bg-gray-100 p-4 rounded text-sm">
          {JSON.stringify(submission, null, 2)}
        </pre>
      ) : (
        <p>No submission data available.</p>
      )}
    </div>
  );
};

export default ViewSubmission;
